import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { setSubcompany } from 'auth/actions';

import Layout from 'components/layout';
import withCompanySelected from 'secured/hocs/withCompanySelected';

import { getListIsFetching, getSubcompanies, getSubcompaniesIds } from 'subcompanies/selectors';
import { getSubcompany, getCompany } from 'auth/selectors';
import { subcompanyFallback } from 'lib/subcompanyAccess';

const states = Layout.StatesReadySwitch;

export default (Element, withSubcompany = true) => {
  class WithSubcompanySelected extends PureComponent {
    static propTypes = {
      companies: PropTypes.object,
      company: PropTypes.object,
      isLoading: PropTypes.bool,
    };

    state = { view: states.LOADING };

    componentWillReceiveProps = (nextProps) => {
      const subcompanyId = nextProps.match.params.sid;
      if (!nextProps.isFetching) {
        const subcompany = nextProps.subcompanies[subcompanyId];
        // feature/acceso-subcompanias: the back lists only the subcompanies the
        // user may enter. One that is not there (not allowed, or deleted): the
        // same section of the first allowed one; none at all: a message. It is
        // checked even when it is already the selected one, because an
        // Administrador may have just removed it from the user's list.
        if (!subcompany) {
          const fallback = subcompanyFallback(
            nextProps.location.pathname,
            nextProps.company.id,
            subcompanyId,
            nextProps.subcompanyIds
          );
          return this.setState(
            fallback.none
              ? { view: states.NO_SUBCOMPANIES }
              : { view: states.REDIRECT_SUBCOMPANY, redirectTo: fallback.to }
          );
        }
        if (!nextProps.subcompany || nextProps.subcompany.id !== subcompanyId) {
          this.props.setSubcompany(subcompany);
        }
      }
      if (
        nextProps.subcompany &&
        nextProps.subcompany.id === subcompanyId &&
        this.state.view !== states.OK
      ) {
        return this.setState({ view: states.OK });
      }
    };

    render = () => (
      <Layout.ReadySwitch
        Element={Element}
        state={this.state.view}
        companyId={this.props.company.id}
        redirectTo={this.state.redirectTo}
        {...this.props}
      />
    );
  }

  const mapStateToProps = (state) => ({
    company: getCompany(state),
    subcompany: getSubcompany(state),
    subcompanies: getSubcompanies(state),
    subcompanyIds: getSubcompaniesIds(state),
    isFetching: getListIsFetching(state),
  });

  const mapDispatchToProps = {
    setSubcompany,
  };

  return withCompanySelected(
    withRouter(connect(mapStateToProps, mapDispatchToProps)(WithSubcompanySelected))
  );
};



// WEBPACK FOOTER //
// src/modules/secured/hocs/withSubcompanySelected.js